import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Loader2, Activity } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/**
 * Editor inline dei 3 contatori "Stato del Territorio" del Centro Operativo.
 */
export const AdminMetrics = ({ token }) => {
  const [metrics, setMetrics] = useState({
    segnalazioni_aperte: 0,
    interventi_effettuati: 0,
    volontari_attivi: 36,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetch(`${BACKEND}/api/operational-metrics`)
      .then((r) => r.json())
      .then((d) => {
        setMetrics({
          segnalazioni_aperte: d.segnalazioni_aperte ?? 0,
          interventi_effettuati: d.interventi_effettuati ?? 0,
          volontari_attivi: d.volontari_attivi ?? 36,
        });
      })
      .catch(() => toast.error("Errore caricamento metriche"))
      .finally(() => setLoading(false));
  }, []);

  const setField = (key) => (e) =>
    setMetrics((m) => ({ ...m, [key]: Math.max(0, Number(e.target.value) || 0) }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await fetch(`${BACKEND}/api/admin/operational-metrics`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", "X-Admin-Password": token },
        body: JSON.stringify(metrics),
      });
      if (!res.ok) throw new Error("Errore salvataggio");
      toast.success("Numeri d'impatto aggiornati");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <section
      data-testid="admin-metrics"
      className="bg-white border border-[#E5E1D8] rounded-xl shadow-sm overflow-hidden"
    >
      <header className="flex items-center justify-between px-5 py-4 border-b border-[#E5E1D8] bg-[#FBF9F6]">
        <div className="flex items-center gap-3">
          <Activity className="w-5 h-5 text-[#2E4F3B]" />
          <h2 className="text-[#1a2620] font-semibold">Stato del territorio (Centro Operativo)</h2>
        </div>
      </header>
      {loading ? (
        <div className="p-10 flex items-center justify-center text-[#5C5C5C]">
          <Loader2 className="w-5 h-5 animate-spin mr-2" />
          Caricamento…
        </div>
      ) : (
        <form onSubmit={save} className="p-5 sm:p-6 grid sm:grid-cols-3 gap-4">
          <NumField
            label="Segnalazioni aperte"
            value={metrics.segnalazioni_aperte}
            onChange={setField("segnalazioni_aperte")}
            testid="metric-segnalazioni-input"
          />
          <NumField
            label="Interventi effettuati"
            value={metrics.interventi_effettuati}
            onChange={setField("interventi_effettuati")}
            testid="metric-interventi-input"
          />
          <NumField
            label="Volontari attivi"
            value={metrics.volontari_attivi}
            onChange={setField("volontari_attivi")}
            testid="metric-volontari-input"
          />
          <div className="sm:col-span-3 flex justify-end">
            <button
              type="submit"
              disabled={saving}
              data-testid="admin-metrics-save"
              className="inline-flex items-center gap-2 bg-[#2E4F3B] hover:bg-[#1f3828] text-white px-5 py-2.5 rounded-lg text-sm font-semibold transition disabled:opacity-60"
            >
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
              Salva metriche
            </button>
          </div>
        </form>
      )}
    </section>
  );
};

const NumField = ({ label, value, onChange, testid }) => (
  <div>
    <label className="block text-xs font-bold uppercase tracking-wider text-[#5C5C5C] mb-1.5">
      {label}
    </label>
    <input
      type="number"
      min={0}
      value={value}
      onChange={onChange}
      data-testid={testid}
      className="w-full bg-white border-2 border-[#E5E1D8] rounded-lg px-3 py-2.5 text-base font-display font-bold text-[#1A1A1A] focus:outline-none focus:border-[#2E4F3B]"
    />
  </div>
);
